import React from "react";
import { motion } from "framer-motion";
import { Github, Mail, ExternalLink, Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-b from-black via-purple-950/40 to-black text-gray-400 py-12 px-6 border-t border-fuchsia-500/20">
      {/* Background effects */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent -z-10" />
      
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 mb-8">
          {/* Left side */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="flex-1"
          >
            <div className="flex items-center gap-2 mb-4">
              <Sparkles className="text-fuchsia-400" size={24} />
              <h2 className="text-white text-2xl font-bold bg-gradient-to-r from-cyan-400 via-fuchsia-500 to-purple-600 bg-clip-text text-transparent">
                AI Upscaler
              </h2>
            </div>
            <p className="text-sm text-gray-400 mb-3 leading-relaxed">
              This is a demo project showcasing full stack web and AI development skills. 
              Built with cutting-edge technology to deliver stunning image upscaling results.
            </p>
            <div className="flex flex-wrap gap-2 mb-4">
              {['React', 'TailwindCSS', 'FastAPI', 'GAN'].map((tech, i) => (
                <span
                  key={i}
                  className="px-3 py-1 text-xs bg-fuchsia-500/10 border border-fuchsia-500/30 rounded-full text-fuchsia-300"
                >
                  {tech}
                </span>
              ))}
            </div>
            <a 
              href="https://yashmakwana.com" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-fuchsia-400 hover:text-fuchsia-300 transition-colors text-sm font-semibold group"
            >
              Visit My Website
              <ExternalLink size={14} className="group-hover:translate-x-1 transition-transform" />
            </a>
          </motion.div>

          {/* Socials */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex flex-col gap-4"
          >
            <h3 className="text-white font-semibold mb-2">Connect</h3>
            <div className="flex items-center gap-4">
              <motion.a
                href="https://github.com/Ya5h10"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.95 }}
                className="p-3 bg-fuchsia-500/10 border border-fuchsia-500/30 rounded-lg hover:bg-fuchsia-500/20 hover:border-fuchsia-500/50 transition-all group"
              >
                <Github size={20} className="text-fuchsia-400 group-hover:text-fuchsia-300" />
              </motion.a>
              <motion.a
                href="mailto:connect@yashmakwana.com"
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.95 }}
                className="p-3 bg-fuchsia-500/10 border border-fuchsia-500/30 rounded-lg hover:bg-fuchsia-500/20 hover:border-fuchsia-500/50 transition-all group"
              >
                <Mail size={20} className="text-fuchsia-400 group-hover:text-fuchsia-300" />
              </motion.a>
            </div>
          </motion.div>
        </div>

        {/* Bottom line */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="border-t border-fuchsia-500/20 pt-6 text-center"
        >
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} AI Upscaler. All rights reserved.
          </p>
          <p className="text-xs text-gray-600 mt-2">
            Powered by Real-ESRGAN and advanced AI technology
          </p>
        </motion.div>
      </div>
    </footer>
  );
}
